import { render, staticRenderFns } from "./FuncionalidadeCustomizadaDetalhe.vue?vue&type=template&id=5b38ff2a"
import script from "./FuncionalidadeCustomizadaDetalhe.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeCustomizadaDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports